import { App } from "antd";
import { useEffect, useState } from "react";
import { getApiError, getPointInfo } from "tm-shared/api";
import { Point } from "tm-shared/types";

import { usePointSelector } from "@/hooks/redux";

interface UsePointReturn {
    point: Point | null;
    pointLoading: boolean;
}

export const usePoint = (pointId: string | undefined = ""): UsePointReturn => {
    const { notification } = App.useApp();

    const storePoint = usePointSelector(pointId);

    const [point, setPoint] = useState<Point | null>(storePoint ?? null);
    const [pointLoading, setPointLoading] = useState(!storePoint);

    useEffect(() => {
        setPoint(storePoint ?? null);
        setPointLoading(!storePoint);
    }, [storePoint]);

    useEffect(() => {
        if (!pointId) return;

        let cancelled = false;

        const fetchPoint = async () => {
            if (storePoint) return;

            try {
                setPointLoading(true);

                const { result } = await getPointInfo({ pointId });

                if (!cancelled) {
                    setPoint(result);
                }
            } catch (error) {
                if (!cancelled) {
                    const { displayMessage } = getApiError(error);

                    notification.error({
                        title: "Не вдалося завантажити маркет",
                        description: displayMessage,
                    });
                }
            } finally {
                if (!cancelled) {
                    setPointLoading(false);
                }
            }
        };

        fetchPoint();

        return () => {
            cancelled = true;
        };
    }, [notification, pointId, storePoint]);

    return { point, pointLoading };
};
